import styled from 'styled-components'
import { WHITE, GRAY_LIGHT, BLACK } from '../../theme/colors'
import { Tooltip, Icon } from 'antd'

export const Container = styled.div`
  background-color: ${WHITE};
  border-bottom: 1px solid #ededed;
  border-top: 1px solid #ededed;
  padding: 1px 0;
  margin-top: 1px;

  @media (max-width: 767px) {
    margin-left: 8px;
  }
`

export const Text = styled.div`
  color: ${WHITE};
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`

export const View = styled.div`
  flex: 1;
`

export const ColumnOne = styled.div`
  flex: 2;
  display: flex;
  align-items: center;

  @media (max-width: 767px) {
    display: none;
  }
`

export const ColumnMiddle = styled.div`
  display: flex;
  align-items: center;
  width: 56px;
  justify-content: center;
  margin-right: 10px;
  border: 1px solid #a9a6ff;
  border-radius: 7px;
  height: fit-content;
  align-self: center;
  padding: 5px;
  color: #7788c1;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background: #9cbeff;
    color: white;
    border-color: #9cbeff;
  }
`

export const HomeIcon = styled(Icon)`
  font-size: 18px;
`

export const ColumnThree = styled.div`
  flex: 8;

  @media (max-width: 1440px) {
    flex: 7;
  }
`

export const ColumnFour = styled.div`
  flex: 2;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1024px) {
    flex: 3;
  }

  @media (max-width: 767px) {
    display: none; 
  }
`

export const Logo = styled.img`
  align-self: center;
  height: 28px;
  padding-left: 10px;

  @media (max-width: 1024px) {
    height: 22px;
    padding-left: 0;
  }
`

export const BackButton = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  position: absolute;
  left: 32px;
`

export const Back = styled.div`
  font-size: 14px;
  line-height: 19px;

  @media (max-width: 1024px) {
    display: none;
  }
`

export const BackIcon = styled.img`
  -webkit-transform: rotate(180deg);
  -moz-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  -o-transform: rotate(180deg);
  transform: rotate(180deg);
  margin-right: 10px;
`

export const Date = styled.div`
  color: #5f6062;
  line-height: 19px;
  font-size: 10px;
  padding: 0 36px;

  @media (max-width: 1440px) {
    padding-left: 20px;
  }

  @media (max-width: 1024px) {  
    margin-right: 14px;
    text-align: right;
    padding: 0;
  }
`

export const Tabs = styled.div`
  display: flex;
  flex-direction: row;
  flex: 3;
`

export const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: ${GRAY_LIGHT};
`

export const DeliveryDiv = styled.div`
  display: flex;

  animation: fade-in-right 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-right {
    0% {
      transform: translateX(12px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
  @media(max-width: 480px) {
    display: none;
  }
`

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
`

export const PopoverText = styled.div`
  font-size: 12px;
  color: ${BLACK};
  font-family: Avenir;
  font-weight: normal;
`

export const InfoIcon = styled(Icon)`
  display: inline-flex;
  margin-top: 5px;
  margin-right: 8px;
  font-size: 12px;
`

export const DeliveryLabels = styled.div`
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: flex-end;
  margin-right: 16px;
  font-size: 13px;
  @media (max-width: 1024px) {
    font-size: 10px;
  }

  @media (max-width: 1440px) {
    font-size: 10px;
  }

  @media (max-width: 480px) {
    flex-flow: row;
    align-items: center;
  }
`

export const DeliveryValue = styled.div`
  font-weight: bold;
  font-family: Avenir;
  @media (max-width: 480px) {
    margin-left: 8px;
  }
`

export const PackageIcon = styled.img`
  max-width: 26px;
  max-height: 26px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterTabsV1Temp/styledComponents.tsx